import { render, staticRenderFns } from "./EmbedAndLinks.vue?vue&type=template&id=53f196a0&scoped=true&"
import script from "./EmbedAndLinks.vue?vue&type=script&lang=js&"
export * from "./EmbedAndLinks.vue?vue&type=script&lang=js&"
import style0 from "./EmbedAndLinks.vue?vue&type=style&index=0&id=53f196a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f196a0",
  null
  
)

export default component.exports